import React from 'react';
import { useParams } from 'react-router';
import { Result } from 'antd';
import { useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { GET_EXTENSION } from '../../../gql/extensions';
import ExtensionDetail from './components/ExtensionDetail';
import ApprovalResultSection from '../../layout/ApprovalResultSection';

const ResultExtension = () => {
  const { id, projectId } = useParams();
  const { data, loading } = useQuery(GET_EXTENSION, {
    variables: {
      ids: [id],
      projectIds: [projectId],
      status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
    },
  });

  const extension = loading ? {} : data.extensions[0];
  const getStatus = ({ status }) => {
    switch (status) {
      case 'APPROVED':
        return 'success';
      case 'REJECTED':
        return 'error';
      case 'VOIDED':
        return 'warning';
      default:
        return '404';
    }
  };
  const getTitle = ({ status }) => {
    switch (status) {
      case 'APPROVED':
        return 'Extension Approved';
      case 'REJECTED':
        return 'Extension Rejected';
      case 'VOIDED':
        return 'Extension Voided';
      default:
        return '404';
    }
  };

  return (
    <PageContainer loading={loading}>
      {!loading && (
        <Result status={getStatus(extension)} title={getTitle(extension)}>
          <ExtensionDetail
            data={data}
            loading={loading}
            title="Extension Detail"
          />
          <ApprovalResultSection
            approvalRoute={data?.extensions[0].approvalRoute}
          />
        </Result>
      )}
    </PageContainer>
  );
};

export default ResultExtension;
